export interface SignalBandFilterDefault {
  lowCut: number;
  highCut: number;
}

export interface BandFilterConfigurableRange {
  min: number;
  max: number;
}

export const AASM_BAND_FILTER_DEFAULTS: Record<string, SignalBandFilterDefault> = {
  ECG: { lowCut: 0.3, highCut: 70 },
  Resp_effort: { lowCut: 0.1, highCut: 15 },
  Resp_flow: { lowCut: 0.1, highCut: 15 },
  EEG_frontal_L: { lowCut: 0.3, highCut: 35 },
  EEG_frontal_R: { lowCut: 0.3, highCut: 35 },
  EOG_R: { lowCut: 0.3, highCut: 35 },
  EOG_L: { lowCut: 0.3, highCut: 35 },
  EMG_mass_R: { lowCut: 10, highCut: 100 },
  EMG_mass_L: { lowCut: 10, highCut: 100 },
  EMG_leg: { lowCut: 10, highCut: 100 },
  Nasal_pressure: { lowCut: 0.03, highCut: 100 }
};

export const BAND_FILTER_CONFIGURABLE_RANGES: Record<string, BandFilterConfigurableRange> = {
  ECG: { min: 0.03, max: 128 },
  Resp_effort: { min: 0.03, max: 32 },
  Resp_flow: { min: 0.03, max: 32 },
  EEG_frontal_L: { min: 0.03, max: 64 },
  EEG_frontal_R: { min: 0.03, max: 64 },
  EOG_R: { min: 0.03, max: 64 },
  EOG_L: { min: 0.03, max: 64 },
  EMG_mass_R: { min: 0.03, max: 128 },
  EMG_mass_L: { min: 0.03, max: 128 },
  EMG_leg: { min: 0.03, max: 128 },
  Nasal_pressure: { min: 0.03, max: 128 }
};

export const NOTCH_FILTERED_SIGNALS: string[] = [
  'ECG',
  'EEG_frontal_L',
  'EEG_frontal_R',
  'EOG_R',
  'EOG_L',
  'EMG_mass_R',
  'EMG_mass_L',
  'EMG_leg'
];

export const hasAdjustableBandFilter = (signalName: string): boolean =>
  Object.prototype.hasOwnProperty.call(AASM_BAND_FILTER_DEFAULTS, signalName);

export const isNotchFilteredSignal = (signalName: string): boolean =>
  NOTCH_FILTERED_SIGNALS.includes(signalName);

export const configurableRangeFor = (signalName: string): BandFilterConfigurableRange =>
  BAND_FILTER_CONFIGURABLE_RANGES[signalName] ?? { min: 0.01, max: Number.MAX_SAFE_INTEGER };
